import { getProfileData } from "../repo/Profile";
import { API_URL } from "../../../../Repository/URL";

export const getUpdatedProfileImage = async (uploadData) => {
  // 업로드 응답의 새 이미지 주소를 우선 사용해 이전 프로필 정보로 덮어쓰지 않습니다.
  let path =
    typeof uploadData === "string" ? uploadData : uploadData?.profileImgPath;
  if (typeof path !== "string" || !path.trim()) {
    const profile = await getProfileData();
    path = profile?.data?.profileImgPath;
  }
  if (typeof path !== "string" || !path.trim()) {
    throw new Error("서버 응답에 프로필 이미지 주소가 없습니다.");
  }

  path = path.trim();
  // 전체 URL과 이미 슬래시로 시작하는 경로는 그대로 유지합니다.
  if (!/^(https?:\/\/|\/)/i.test(path)) path = `/${path}`;

  // 서버가 같은 파일을 덮어쓸 수 있으므로 갱신된 주소를 Redux로 공유합니다.
  // 업로드한 파일은 API 서버의 최상위 경로에서 제공됩니다.
  const imageOrigin = new URL(API_URL, window.location.origin).origin;
  const url = new URL(path, imageOrigin);
  url.searchParams.set("profileUpdatedAt", Date.now().toString());
  return url.href;
};

export const createDefaultProfileFile = () =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = 256;
        canvas.height = 256;
        const context = canvas.getContext("2d");
        if (!context) throw new Error("기본 프로필 이미지를 생성할 수 없습니다.");
        context.fillStyle = "#e3efff";
        context.fillRect(0, 0, 256, 256);
        context.drawImage(image, 48, 48, 160, 160);
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("기본 프로필 이미지를 생성할 수 없습니다."));
            return;
          }
          resolve(new File([blob], "default-profile.png", { type: "image/png" }));
        }, "image/png");
      } catch (error) {
        reject(error);
      }
    };
    image.onerror = () => reject(new Error("기본 프로필 이미지를 불러올 수 없습니다."));
    image.src = "/User.svg";
  });
